import React from 'react'
import {
    Input,
} from 'reactstrap'

class MemoryTextField extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'oldvalue': props.value,
            'value': props.value,
        }
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.props.onHitEnter(this.state.value)
        }
    }

    render() {
        if (this.state.oldvalue !== this.props.value) {
            this.setState({
                'oldvalue': this.props.value,
                'value': this.props.value,
            })
        }

        return <Input
            value={this.state.value}
            type="text"
            onKeyDown={this._handleKeyDown}
            onBlur={() => {
                this.props.onHitEnter(this.state.value)
            }}
            onChange={(e) => {
                this.setState({
                    'value': e.target.value
                })
            }}
            />
    }
}

const MemoryNumberTextField = (props) => {
    return <MemoryTextField
        value={props.value}
        onHitEnter={(value) => {
            props.onHitEnter(Number.parseFloat(value))
        }}
        />
}

export { MemoryTextField, MemoryNumberTextField }
